import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-exemplo-vistoria-cautelar',
  templateUrl: './exemplo-vistoria-cautelar.component.html',
  styleUrls: ['./exemplo-vistoria-cautelar.component.scss']
})
export class ExemploVistoriaCautelarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  menuItems = [
    { link: 'topico0', text: 'Resumo ', active: true },
    { link: 'topico1', text: 'Estrutura ', active: false },
    { link: 'topico2', text: 'Pintura ', active: false },
    { link: 'topico3', text: 'Etiquetas ', active: false },
    { link: 'topico4', text: 'Vidros ', active: false },
    { link: 'topico5', text: 'Identificação ', active: false },
    { link: 'topico6', text: 'Veículo ', active: false },
    { link: 'topico7', text: 'Fotos Adicionais ', active: false },
    { link: 'topico8', text: 'Resumo Decisão Certa  ', active: false },
    { link: 'topico9', text: 'Dados Estaduais ', active: false },
    { link: 'topico10', text: 'Dados Nacionais ', active: false },
    { link: 'topico11', text: 'Histórico de Roubo e Furto ', active: false },
    { link: 'topico12', text: 'Indício de Sinistro ', active: false },
    { link: 'topico13', text: 'Parecer Técnico ', active: false },
    { link: 'topico14', text: 'VIN - Decode ', active: false },
    { link: 'topico15', text: 'Remarketing ', active: false },
    { link: 'topico16', text: 'Localizador de Chassi e Motor ', active: false },
    { link: 'topico17', text: 'Base de Leilão 1 ', active: false },
    { link: 'topico18', text: 'Base de Leilão 2', active: false },
    { link: 'topico19', text: 'Base de Leilão 3 ', active: false },
    { link: 'topico20', text: 'Histórico de Proprietários ', active: false },
    { link: 'topico21', text: 'Preço de Mercado Financeiro ', active: false },
    { link: 'topico22', text: 'Desvalorização Média ', active: false },
  ];


  topicos = [
    { id: 0, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t31_certo.png'], botoes: null },
    { id: 1, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t31_certo2.png'], botoes: null },
    { id: 1, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t35-1.png'], botoes: null },
    { id: 2, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t36.png'], botoes: null },
    { id: 3, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t37.png'], botoes: null },
    { id: 4, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t38.png'], botoes: null },
    { id: 5, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t39.png'], botoes: null },
    { id: 6, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t310.png'], botoes: null },
    { id: 7, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t311.png'], botoes: null },
    { id: 8, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t312_certo.png'], botoes: null },
    { id: 9, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t316.png'], botoes: null },
    { id: 10, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t317.png'], botoes: null },
    { id: 11, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t318.png'], botoes: null },
    { id: 12, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t319_certo.png'], botoes: null },
    { id: 13, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t116.png'], botoes: null },
    { id: 14, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t322.png'], botoes: null },
    { id: 15, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t323.png'], botoes: null },
    { id: 16, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t324.png'], botoes: null },
    { id: 17, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t325.png'], botoes: null },
    { id: 18, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t326.png'], botoes: null },
    { id: 19, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t327.png'], botoes: null },
    { id: 20, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/hp-1.png'], botoes: null },
    { id: 21, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/pmf-1.png'], botoes: null },
    { id: 22, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t214.png'], botoes: null },
  ];

  imgAtiva = {
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 1,
    7: 1,
    8: 1,
    9: 1,
    10: 1,
    11: 1,
    12: 1,
    13: 1,
    14: 1,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 1,
    20: 1,
    21: 1
  };

  mostraImagem(topicoId: number, imgId: number) {
    this.imgAtiva[topicoId] = imgId;

    const topico = this.topicos.find(t => t.id === topicoId);
    if (topico && topico.botoes) {
      topico.botoes.forEach(botao => botao.ativo = (botao.id === imgId));
    }
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.updateActiveMenuItem(id);
    }
  }

  updateActiveMenuItem(activeLink: string) {
    this.menuItems.forEach(item => item.active = (item.link === activeLink));
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const distanciaDoTopo = 150;

    this.menuItems.forEach((item) => {
      const element = document.getElementById(item.link);
      if (element) {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;

        if (elementTop <= window.scrollY + distanciaDoTopo) {
          this.updateActiveMenuItem(item.link);
        }
      }
    });
  }


}
